import type { ReactNode } from "react";
import { Dialog } from "../ui/Dialog.js";
import { Kbd } from "../ui/primitives.js";
import { modifierLabel, shortcutGroups } from "./shortcuts.js";
import type { ShortcutGroup } from "./shortcuts.js";

export function ShortcutsDialog(props: { readonly open: boolean; readonly onClose: () => void }): ReactNode {
  const groups = shortcutGroups(modifierLabel());
  return (
    <Dialog open={props.open} onClose={props.onClose} title="Tastenkürzel" description="Schneller arbeiten, ohne die Maus." size="lg">
      <div className="grid gap-x-8 gap-y-6 p-5 sm:grid-cols-2">
        {groups.map((group: ShortcutGroup) => (
          <section key={group.title}>
            <h3 className="text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-mist-2">{group.title}</h3>
            <dl className="mt-2 divide-y divide-line">
              {group.items.map((item) => (
                <div key={item.label} className="flex items-center justify-between gap-4 py-2">
                  <dt className="text-sm text-foam">{item.label}</dt>
                  <dd className="flex shrink-0 items-center gap-1">
                    {item.keys.map((key: string, index: number) => (
                      <Kbd key={`${key}-${index}`}>{key}</Kbd>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
